module.exports = __webpack_public_path__ + "static/media/chandrabindu_au.8cec1f13.ogg";